module.exports = __webpack_public_path__ + "static/media/battery.e3f8c9e2.svg";